export const PageDataState = {
    Searchs: {
        eec_nets_id: {
            type: 'text',
            id: 'eec_nets_id',
            label: '',
            value: '',
        },
        eec_nets_public_data_name: {
            type: 'text',
            id: 'eec_nets_public_data_name',
            label: 'หัวข้อ',
            value: '',
            placeholder: 'หัวข้อ',
        },
        eec_nets_public_data_status: {
            type: 'select',
            id: 'eec_nets_public_data_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        eec_nets_id: {
            type: 'select',
            id: 'eec_nets_id',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        name: {
            type: 'text',
            id: 'name',
            label: 'หัวข้อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '3',
            id: 'description',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        attach_file: {
            type: 'file',
            id: 'attach_file',
            label: 'เอกสารเผยแพร่/นำเสนอ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }       
    },
    InputGroup: {}
}